import { useState, useContext } from "react";
import { useAuth } from "../../auth/useAuth";
import { Domains } from "../../data/Domains";
import { HttpMethods } from "../../data/HttpMethods";
import { NotificationTypes } from "../../data/NotificationTypes";
import VillageConsoleContext from "../../store/VillageConsoleContext";
import { fetchData, getHttpOptions } from "../../utils/http.util";


export const useManageSmsTemplates = ( ): {

    getSmsTemplate( domain: Domains ): Promise< string | undefined >
    , uploadSmsTemplate( domain: Domains, smsTemplate: string ): Promise< boolean >

} => {

    const { functionKey, setNotificationText, setNotificationType } = useContext( VillageConsoleContext );
    const { getIdToken } = useAuth( );
    
    
    const getSmsTemplate = async ( domain: Domains ): Promise< string | undefined > => {

        const query = `${process.env.REACT_APP_API_URL}/sms-template?domain=${ domain }`;
        const idToken: string = await getIdToken( );
        const options = getHttpOptions( idToken, functionKey!, HttpMethods.Get );

        const response = await fetchData( options, query  );

        if ( response.statusCode !== 200 ) {

            setNotificationType( NotificationTypes.Error );
            setNotificationText( `Error fetching SMS Template for ${domain}` );

            return undefined;

        }

        return await response.response?.text( );
  
    };

    
    const uploadSmsTemplate = async ( domain: Domains, smsTemplate: string ): Promise< boolean > => {

        const query = `${process.env.REACT_APP_API_URL}/sms-template?domain=${ domain }`;
        const idToken: string = await getIdToken( );
        const options = getHttpOptions( idToken, functionKey!, HttpMethods.Post, smsTemplate );

        const response = await fetchData( options, query  );

        if ( response.statusCode !== 200 ) {

            setNotificationType( NotificationTypes.Error );
            setNotificationText( `Error updating SMS template for ${domain}` );
            return false;

        }

        setNotificationType( NotificationTypes.Success );
        setNotificationText( 'SMS Template successfully updated' );
        return true;

    };


    return {

        getSmsTemplate
        , uploadSmsTemplate

    };

};